import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PermissionsService } from 'app/core/permissions.service';
import { PermissionKeys as Keys } from './core/auth/permission-keys';
import { AuthorizationGuard, AuthorizationGuardService } from './core/authorization-guard.service';
import { PageNotFoundComponent } from './page-not-found.component';
import { UserPermissionKeys } from './security/authorization/user-permission-keys';
import { DashboardComponent } from './views/dashboard/dashboard.component';

const permissionsKeys = new UserPermissionKeys();

const routes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [AuthorizationGuard], pathMatch: 'full' },
  { path: ':catalog/dashboard', component: DashboardComponent, canActivate: [AuthorizationGuard], pathMatch: 'full' },
  {
    path: ':catalog/admin',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: ':catalog/analysis',
    loadChildren: () => import('./runnable-models/runnable-models.module').then(m => m.RunnableModelsModule),
  },
  {
    path: ':catalog/assets',
    loadChildren: () => import('./asset-management/asset-management.module').then(m => m.AssetManagementModule),
  },
  {
    path: ':catalog/functions',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.buildFunctionRead],
      },
    },
    loadChildren: () => import('./functions/functions.module').then(m => m.FunctionsModule),
  },
  {
    path: ':catalog/library-nodes',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    loadChildren: () => import('./library-nodes/library-nodes.module').then(m => m.LibraryNodesModule),
  },
  {
    path: ':catalog/events',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.eventsEventItemRead],
      },
    },
    loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
  },
  {
    path: ':catalog/hierarchy',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.hierarchyHierarchyItemRead],
      },
    },
    loadChildren: () => import('./hierarchy/hierarchy.module').then(m => m.HierarchyModule),
  },
  {
    path: ':catalog/reports',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.reportsAllRead],
      },
    },
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
  },
  {
    path: ':catalog/idms',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    loadChildren: () => import('./idms/idms.module').then(m => m.IdmsModule),
  },
  {
    path: ':catalog/lookups-old',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.buildLookupRead],
      },
    },
    loadChildren: () => import('./lookups/lookups.module').then(m => m.LookupsModule),
  },
  {
    path: ':catalog/planned-maintenance-library',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.adminMaintenancePlannedMaintenanceRead],
      },
    },
    loadChildren: () => import('./planned-maintenance-library/planned-maintenance-library.module').then(m => m.PlannedMaintenanceLibraryModule),
  },
  {
    path: ':catalog/maintenance-strategies-library',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.adminMaintenanceMaintenanceStrategyRead],
      },
    },
    loadChildren: () =>
      import('./maintenance-strategies-library/maintenance-strategies-library.module').then(m => m.MaintenanceStrategiesLibraryModule),
  },
  {
    path: ':catalog/models',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      permission: {
        only: [permissionsKeys.buildModelRead],
      },
    },
    loadChildren: () => import('./models/models.module').then(m => m.ModelsModule),
  },
  { path: ':catalog/nodes', loadChildren: () => import('./nodes/nodes.module').then(m => m.NodesModule) },
  {
    path: ':catalog/thickness-management',
    loadChildren: () => import('./thickness-management/thickness-management.module').then(m => m.ThicknessManagementModule),
  },
  {
    path: ':catalog/security-new',
    canActivate: [AuthorizationGuard],
    canActivateChild: [AuthorizationGuard],
    data: {
      claimPermission: {
        only: [Keys.IsSecurity],
      },
    },
    loadChildren: () => import('./security/security.module').then(s => s.SecurityModule),
  },
  { path: '**', pathMatch: 'full', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [PermissionsService, AuthorizationGuardService],
})
export class AppRoutingModule { }
